import { Injectable, Inject } from '@angular/core';
import { AritcoController } from './aritcoController';
import { AritcoRequest, ApiResponse } from '../models';
import { AppStore, HttpAction, ActionStatus } from '../state';
import { BaseActionCreator } from '../baseActionCreator';

@Injectable({
  providedIn: 'root',
}) 
export class AritcoActionCreator extends BaseActionCreator {

  constructor(
    @Inject(AritcoController) public aritcoController: AritcoController,
    @Inject(AppStore) public appStore: AppStore
  ) { super(aritcoController)
  }

  public get(aritcoRequest: AritcoRequest): HttpAction<ApiResponse> {

    return this.createHttpAction<ApiResponse>(
      "Request aritco update comparision codes",
      (dispatch, state, callback) => {

        return this.aritcoController.get(aritcoRequest).subscribe((response) => {

          dispatch({ type: "Aritco result fetched", payload: response });

          // Update complete request status
          callback(new ActionStatus(true, response));
        })
      });
  }

  public createHttpAction<T>(actionType: any, executeAsync: any, payload?: T): HttpAction<T> {

    let httpAction: HttpAction<T> = {
      type: actionType,
      executeAsync: executeAsync,
      payload: payload
    }

    return httpAction;
  }  
}
